// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : qa parts
// =============================================================================
// ---Third-party imports
import React from 'react';
import { loadLazy as ll, funcPart } from 'uix/parts';
// ---Exports
export const TreeStates = ll(()=>import(/* webpackChunkName: 'qa' */ './states'));
export const TreeQA = ll(()=>import(/* webpackChunkName: 'qa' */ './pageinfo'));
